import NewDateField from "../../DesignSystem/Inputs/NewDateField";
import NewInputField from "../../DesignSystem/Inputs/NewInputField";
import NewInputTextArea from "../../DesignSystem/Inputs/NewTextArea";
import ReferenceForm from "./ReferenceForm";

const EducationalReferenceDetails = ({
  form,
  update,
  validationErrors,
  isReferenceNotRequired = false,
}) => (
  <>
    <NewInputField
      label="Type of Reference"
      value="Educational Reference"
      disabled
    />
    <div className="grid2 gap-m">
      <NewDateField
        label="Education From"
        value={form.educationFrom}
        onChange={(event) => update("educationFrom", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.educationFrom}
        helperText={validationErrors.educationFrom ? "Education From is required." : ""}
      />
      <NewDateField
        label="Education To"
        value={form.educationTo}
        onChange={(event) => update("educationTo", event.target.value)}
        required={!isReferenceNotRequired}
        error={validationErrors.educationTo}
        helperText={validationErrors.educationTo ? "Education To is required." : ""}
      />
    </div>
    <NewInputTextArea
      label="Further Details"
      value={form.educationDetails}
      onChange={(event) => update("educationDetails", event.target.value)}
      placeholder="Name of school or university, course and any relevant programme details"
      maxLength={2000}
      required={!isReferenceNotRequired}
      error={validationErrors.educationDetails ? "Further Details are required." : ""}
    />
  </>
);

const EducationalReferenceForm = (props) => (
  <ReferenceForm
    {...props}
    referenceKind="educational"
    DetailsFields={EducationalReferenceDetails}
  />
);

export default EducationalReferenceForm;
